<template>
  <div>
    <textInput
      v-if="showIban"
      :labelKey="'iban'"
      :inputId="'iban'"
      :pattern="'^[A-Za-z]{2}\\d{2}[A-Za-z0-9]{11,30}$'"
      :errorLabelKey="'iban' + '-field-not-ok'"
      :maxlength="'350'"
      :required="ibanRequired"
      :ref="'iban'"
      :type="'text'"
      @textInput-changed="onIbanChange"
    />
  </div>
  <div>
    <textInput
      v-if="showIntestatario"
      :labelKey="'intestatario'"
      :inputId="'intestatario'"
      :pattern="patternIntestatario"
      :errorLabelKey="'intestatario' + '-field-not-ok'"
      :maxlength="'350'"
      @textInput-changed="onIntestatarioChange"
      :required="intestatarioRequired"
      :ref="'intestatario'"
      :type="'text'"
    />
  </div>
  <div>
    <textInput
      v-if="showBicswift"
      :labelKey="'bic_swift'"
      :inputId="'bic_swift'"
      :pattern="'^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$'"
      :errorLabelKey="'bic_swift' + '-field-not-ok'"
      :maxlength="'350'"
      @textInput-changed="onBicSwiftChange"
      :required="bic_swiftRequired"
      :ref="'bic_swift'"
      :type="'text'"
    />
  </div>

</template>

<script>
import intl from "./intl/intl";
import TextInput from "../textInput/TextInput.vue";

export default {
  name: "iban",
  components: {
    textInput: TextInput,
  },

  props: {
    inputId: {
      type: String,
      default: null,
    },
    ibanRequired: {
      type: Boolean,
      default: false,
    },
    intestatarioRequired: {
      type: Boolean,
      default: false,
    },
    errorLabelKey: {
      type: String,
      default: null,
    },
    labelKey: {
      type: String,
      default: null,
    },
    patternIban: {
      type: String,
      default: null,
    },
    patternIntestatario: {
      type: String,
      default: null,
    },
    showIban: {
      type: Boolean,
      default: false,
    },
    showIntestatario: {
      type: Boolean,
      default: false,
    },
    showBicswift: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  beforeUnmount() {},
  data: function () {
    return {
      intl: intl,
      inputField: {},
      iban: "",
      intestatario: "",
      bic_swift: "",
      showAlert: false,
      bic_swiftRequired: false,
    };
  },
  methods: {
    onIbanChange(iban, inputId) {
      this.iban = iban;
      this.inputField["iban"] = iban;
      if (this.showBicswift) {
        if (
          this.iban?.length >= 2 &&
          !this.iban.toUpperCase().startsWith("IT")
        ) {
          this.bic_swiftRequired = true
        }else{
          this.bic_swiftRequired = false
        }
        this.$refs["bic_swift"].setRequired(this.bic_swiftRequired)
        this.$refs["bic_swift"].requiredInputIsOk()
      }
    },
    onIntestatarioChange(intestatario, inputId) {
      this.intestatario = intestatario;
      this.inputField["intestatario"] = intestatario;
    },
    onBicSwiftChange(bic_swift, inputId) {
      this.bic_swift = bic_swift;
      this.inputField["bic_swift"] = bic_swift;
   
      this.$refs["bic_swift"].requiredInputIsOk()

    },

    requiredInputIsOk() {
      let isOk = false;
      if (Object.keys(this.inputField)?.length > 0) {
        if (this.showIban && this.ibanRequired) {
          isOk = this.$refs["iban"].requiredInputIsOk();
        }
        if (this.showIntestatario && this.intestatarioRequired) {
          isOk = isOk &&  this.$refs["intestatario"].requiredInputIsOk();
        }
        if (this.showBicswift && this.bic_swiftRequired) {
          isOk = isOk && this.$refs["bic_swift"].requiredInputIsOk();
        }
      }
      if (!isOk) {
        this.showAlert = true;
      } else {
        this.showAlert = false;
      }
      return isOk;
    },
  },
  watch: {},
  computed: {
    /* bic_swiftRequired: function () {
      if (this.iban?.length > 2 && !this.iban.toUpperCase().startsWith("IT")) {
        return true;
      } else {
        return false;
      }
    }, */
  },
};
</script>
